import React, { PropTypes, Component } from 'react';
import ReactGA from 'react-ga';
// Ads
// import bgEn from '../../../assets/images/background-right-en-kore.png';
// import bgEs from '../../../assets/images/background-right-es-kore.png';
// import bgPt from '../../../assets/images/background-right-pt-kore.png';
// Styles
import './ads.css';

const propTypes = {
  locale: PropTypes.string.isRequired,
};

class BackgroundLeft extends Component {
  componentDidMount() {
    ReactGA.event({
      category: 'Ads',
      action: `Visualizou o Fundo Direito (Background) (${this.props.locale})`,
      opt_label: 'banner, background, view',
    });
  }

  render() {
    // const locale = this.props.locale;
    let bgRight;

    // switch (locale) {
    //   case 'pt':
    //     bgRight = bgPt;
    //     break;
    //   case 'es':
    //     bgRight = bgEs;
    //     break;
    //   default:
    //     bgRight = bgEn;
    // }

    const right = {
      backgroundImage: `url(${bgRight})`,
    };

    const handleClick = () => {
      ReactGA.event({
        category: 'Ads',
        action: `Clicou no Fundo Direito (Background) (${this.props.locale})`,
        opt_label: 'banner, background, click',
      });
    };

    return (
      <a
        onClick={handleClick}
        href=""
        className="right bg three wide computer only column"
        style={right}
      />
    );
  }
}

BackgroundLeft.propTypes = propTypes;

export default BackgroundLeft;



/** WEBPACK FOOTER **
 ** ./src/components/layout/ads/BackgroundRight.js
 **/